import { StorefrontCart, StorefrontCartItem } from "src/components/checkout/types"
import { ResolvedListProductData } from "src/data/product-list-resolved/types"
import { wcDeleteItemFromCart, wcGetCart } from "src/data/woocommerce/wcStoreApi"
import { WCStoreCart } from "src/data/woocommerce/wcStoreTypes"
import { recordError } from "src/utilities/errorReporting"

export async function mapCart(_cart: WCStoreCart, productsBySku: Map<string, ResolvedListProductData>) {
  let rawCart: WCStoreCart | null = _cart

  if (!rawCart) {
    throw new Error("Cart not found")
  }

  let healed = false

  // If for some reason a product went offline, remove it from the cart.
  for (const item of rawCart.items) {
    if (!productsBySku.has(item.sku)) {
      recordError(`Product not found for cart item: ${JSON.stringify({ sku: item.sku, name: item.name })}`)
      await wcDeleteItemFromCart(item.key)
      healed = true
    }
  }

  if (healed) {
    rawCart = await wcGetCart()

    if (!rawCart) {
      throw new Error("Cart not found after healing")
    }
  }

  const items = rawCart.items.flatMap((item) => {
    const product = productsBySku.get(item.sku)

    if (!product) {
      return []
    }

    return { ...item, product } satisfies StorefrontCartItem
  })

  return { ...rawCart, items } satisfies StorefrontCart
}
